// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page-style {
  max-height: calc(100vh - 150px);
  overflow: auto;
}

.nav-pointer {
  cursor: pointer;
}

.login-style {
  font-size: 20px;
  margin-top: 0px;
}

.header-style {
  color: #C3C3C3;
  font-size: 28px;
  position: relative;
  left: 0;
  font-weight: 600;
}

.example-form {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}

.example-full-width {
  width: 100%;
}

.card-style {
  margin: 1% 30%;
}

.button-style {
  margin-right: 10px;
  float: right;
  padding: 0px 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;EACA,cAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,eAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,gBAAA;AACJ;;AACA;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,cAAA;AAEJ;;AACA;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;AAEJ","sourcesContent":[".login-page-style{\n    max-height: calc(100vh - 150px);\n    overflow: auto;\n}\n\n.nav-pointer{\n    cursor: pointer;\n}\n\n.login-style{\n    font-size: 20px;\n    margin-top: 0px;\n}\n\n.header-style{\n    color: #C3C3C3;\n    font-size: 28px;\n    position: relative;\n    left: 0;\n    font-weight: 600;\n}\n.example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n}\n  \n.example-full-width {\n    width: 100%;\n}\n\n.card-style{\n    margin: 1% 30%;\n}\n\n.button-style{\n    margin-right: 10px; \n    float: right;\n    padding: 0px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
